import styled from 'styled-components';

export const StyledPatientAutosuggest = styled.div`
   display: flex;
   justify-content: center;
   gap: 15px;
`;
StyledPatientAutosuggest.displayName = 'StyledPatientAutosuggest';
